<template lang="html">
    <div class="container container-small">
        <Heading class="py-4" v-if="this.car" :title="this.car._plateNo" :routeName="'my-cars'"></Heading>
        <template v-if="!loading">
            <template v-if="car">
                <div class="mt-0">
                    <div class="row">
                        <div class="col-12 col-md-5">
                            <div class="form-group">
                                <label>{{ $t('label_license_plate') }}</label>
                                <input type="text" class="form-control" v-model="car._plateNo" v-bind:class="{'has-error': errorMsgs._plateNo}">
                                <span class="invalid-feedback">
                                    {{errorMsgs._plateNo}}
                                </span>

                            </div>
                        </div>
                        <div class="col-12 col-md-7">
                            <div class="form-group">
                                <label>{{ $t('label_chasis_number') }}</label>
                                <input type="text" class="form-control" v-model="car._chasisNo" v-bind:class="{'has-error': errorMsgs._chasisNo}">
                                <span class="invalid-feedback">
                                    {{errorMsgs._chasisNo}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="countries">
                        <label for="taraInmatriculare">{{ $t('label_registration_country') }}</label>
                        <select class="form-control" id="taraInmatriculare" v-model="car._country" >
                            <option v-for="c in countries" :value="c.id">{{c.country}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('label_choose_category') }} <b>{{ $tc('vignetteWord', 1) }}</b>:</label>
                        <div class="list-group mt-1">
                            <span class="invalid-feedback">
                                <b>{{errorMsgs._category}}</b>
                            </span>
                            <div class="list-group-item list-group-item-action" v-for="(item, key) in categoriesVignette" v-bind:key="key" v-bind:class="[{'active' : car._category == item.id}]" v-on:click="setCategoryVignette(item.id)">
                                <p>{{ capitalize($t('category')) }} {{item.title}}</p>
                                <span v-html="item.desc"></span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('label_choose_category') }} <b>{{ $tc('tollWord', 1) }}</b>:</label>
                        <div class="list-group mt-1">
                            <span class="invalid-feedback">
                                <b>{{errorMsgs._category_TPF}}</b>
                            </span>
                            <div class="list-group-item list-group-item-action" v-for="(item, key) in categoriesToll" v-bind:key="key" v-bind:class="[{'active' : car._category_TPF == item.id}]" v-on:click="setCategoryToll(item.id)">
                                <p>{{item.title}}</p>
                                <span v-html="item.desc"></span>
                            </div>
                        </div>
                    </div>

                    <div class="text-center pt-3 pb-4">
                        <button @click="updateCar()" class="btn btn-purple w-100">{{ $t('btn_save_changes') }}</button>
                    </div>

                    <div class="pb-4 text-right">
                        <a class="text-danger pointer" v-on:click="remove()"><i class="fa fa-trash my-auto" aria-hidden="true"></i> {{ $t('btn_delete_car') }}</a>
                    </div>
                </div>
            </template>
            <template v-else>
                <br/>
                <div>
                    <div class="text-center">
                        <div class="alert alert-danger">{{ $t('edit_car_no_vehicles') }}</div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import { mapActions } from 'vuex'

export default {
    data: function() {
        return {
            car: null,
            countries: null,
            categoriesToll: null,
            categoriesVignette: null,
            errorMsgs: {
                _plateNo: '',
                _chasisNo: '',
                _category: '',
                _category_TPF: '',
            },
            loading: false,
            saving: false
        }
    },
    components: {
        Heading
    },
    props: ['id'],
    mounted: function() {
        this.init();
    },
    watch: {
        'car._plateNo': function(newVal, oldVal) {
            this.car._plateNo = newVal.toUpperCase();
        },
    },
    methods: {
        ...mapActions('vehicles', {
            actionUpdateVehicle: 'updateVehicle',
            actionGetVehicle: 'getVehicle',
            actionDeleteVehicle: 'deleteVehicle'
        }),

        async init() {
            this.loading = true;

            await this.getCountries();
            await this.getCategoriesToll();
            await this.getCategoriesVignette();

            //getting the vehicle
            if(this.$store.getters['vehicles/getVehicle'] != null && this.$store.getters['vehicles/getVehicle'].id == this.$route.params.id) {
                this.car = this.$store.getters['vehicles/getVehicle'];
                this.loading = false;
            }
            else {
                let response = await this.actionGetVehicle(this.id);
                this.car = response.data.vehicle;
                this.loading = false;
            }
        },

        async getCountries() {
            if(this.$store.getters['countries/getCountries'] != null) {
                this.countries = this.$store.getters['countries/getCountries'];
            }
            else {
                await this.$store.dispatch('countries/getCountries').then(response => {
                    this.countries = response.data.countries;
                }, error => {
                    this.$dialog.alert({
                        'message':  this.$t('countries_loading'),
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                });
            }
        },

        async getCategoriesToll() {
            if(this.$store.getters['categories/getCategoriesToll'] != null) {
                this.categoriesToll = this.$store.getters['categories/getCategoriesToll'];
            }
            else {
                await this.$store.dispatch('categories/getCategoriesToll').then(response => {
                    this.categoriesToll = response.data.categories;
                }, error => {
                    this.$dialog.alert({
                        'message':  this.$t('tpf_categories_loading'),
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                });
            }
        },

        async getCategoriesVignette() {
            if(this.$store.getters['categories/getCategoriesVignette'] != null) {
                this.categoriesVignette = this.$store.getters['categories/getCategoriesVignette'];
            }
            else {
                await this.$store.dispatch('categories/getCategoriesVignette').then(response => {
                    this.categoriesVignette = response.data.categories;
                }, error => {
                    this.$dialog.alert({
                        'message':  this.$t('erv_categories_loading'),
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                });
            }
        },

        setCategoryVignette(id) {
            this.car._category = id;
        },

        setCategoryToll(id) {
            this.car._category_TPF = id;
        },

        validate()
        {
            this.clearErrors(this.errorMsgs);

            var ok = true;

            var mandatoryText = this.$t('mandatory');

            if(!this.car._plateNo) {
                ok = false;
                this.errorMsgs._plateNo = mandatoryText;
            }

            let plateNoOk = this.validatePlateNo(this.car._plateNo, this.car._country);

            if(!plateNoOk) {
                ok = false;
                this.errorMsgs._plateNo = this.$t('invalid_plate_number_message');
            }

            if(!this.car._chasisNo) {

                ok = false;
                this.errorMsgs._chasisNo = mandatoryText;
            }
            else if(!this.validateChasisNo(this.car._chasisNo)) {

                ok = false;
                this.errorMsgs._chasisNo = this.$t('invalid');
            }

            if(!this.car._category) {
                ok = false;
                this.errorMsgs._category = mandatoryText;
            }

            if(!this.car._category_TPF) {
                ok = false;
                this.errorMsgs._category_TPF = mandatoryText;
            }

            if (!ok) {
                var element = $('.invalid-feedback')[0];
                element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            }

            return ok;
        },

        async updateCar()
        {
            if(!this.validate()) return false;

            this.saving = true;

            this.actionUpdateVehicle(this.car).then(response => {

                //updated vehicle
                this.saving = false;

                this.$router.push({ name: 'my-cars' });

            }).catch(error => {
                this.saving = false;

                if(error.response) {
                    this.$dialog.alert({
                        'message': error.response.data.errors.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            });
        },

        remove() {

            this.$dialog.confirm({
                title: this.$t('edit_car_delete_vehicle_title'),
                message: this.$t('edit_car_delete_vehicle'),
                cancelButtonText: this.$t('no'),
                confirmButtonText: this.$t('yes'),
                beforeClose: this.doRemoveVehicle
            })
            .then(() => {
                this.$router.push({ name: 'my-cars' });
            })
            .catch(() => {
                // on cancel
            });
        },

        doRemoveVehicle(action, done) {
            if(action == 'confirm') {
                this.actionDeleteVehicle(this.car.id).then(async response => {
                    done();
                }).catch(err => {
                    if(err.response) {
                        this.$dialog.alert({
                            'message': err.response.data.error.error_msg,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                    done();
                });
            }
            else {
                done();
            }
        }
    }
}
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #272D37;

.logout {
    display: inline-block;
    float: right;

    .fa-sign-out-alt{
        font-size: 24px;
    }
    a:link {
        color: white;
        text-decoration: none;
    }
    a:visited {
        color: white;
        text-decoration: none;
    }
    a:hover {
        color: white;
        text-decoration: none;
    }
    a:active {
        color: white;
        text-decoration: none;
    }
}

.list-group {
    .active {
        border-color: $green;
        border-left-width: 10px;
        background: inherit;
        color: inherit;
    }
    .list-group-item {
        padding: 6px 12px;
        p {
            margin: 0px;

        }
        span {
            color: $lightgrey;
            font-size: 12px;
        }
    }
}

.form-group {
    margin-bottom: 1rem;
}


</style>
